var Index_object_review_slide_slider = document.querySelector('.Index_object_review_slide_slider');

if (Index_object_review_slide_slider) {
    new Swiper('.Index_object_review_slide_slider', {
        loop: true,
        grabCursor: false,
        spaceBetween: 10,
        slidesPerGroup: 1,
        slidesPerView: 1,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        effect: "fade",
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
        breakpoints: {
            0: {
            },
            750: {
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
}